/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CompetenceId202,
  PutApiV1CompetenceId400,
  PutApiV1CompetenceId401,
  PutApiV1CompetenceId404,
  PutApiV1CompetenceId500,
  PutApiV1CompetenceIdMutationRequest,
  PutApiV1CompetenceIdMutationResponse,
  PutApiV1CompetenceIdPathParams,
} from "../../types/competenceRegistroController/PutApiV1CompetenceId.ts";
import { competenceViewModelSchema } from "../competenceViewModelSchema.ts";
import { updateCompetenceRequestViewModelSchema } from "../updateCompetenceRequestViewModelSchema.ts";

export const putApiV1CompetenceIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1CompetenceIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1CompetenceId202Schema = z.lazy(
  () => competenceViewModelSchema,
) as unknown as ToZod<PutApiV1CompetenceId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CompetenceId400Schema =
  z.any() as unknown as ToZod<PutApiV1CompetenceId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CompetenceId401Schema =
  z.any() as unknown as ToZod<PutApiV1CompetenceId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1CompetenceId404Schema =
  z.any() as unknown as ToZod<PutApiV1CompetenceId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CompetenceId500Schema =
  z.any() as unknown as ToZod<PutApiV1CompetenceId500>;

export const putApiV1CompetenceIdMutationRequestSchema = z.lazy(
  () => updateCompetenceRequestViewModelSchema,
) as unknown as ToZod<PutApiV1CompetenceIdMutationRequest>;

export const putApiV1CompetenceIdMutationResponseSchema = z.lazy(
  () => putApiV1CompetenceId202Schema,
) as unknown as ToZod<PutApiV1CompetenceIdMutationResponse>;
